export const initialState = {
  verifiedOffers: [],
}

export default () => ({ ...initialState })
